module.exports = __webpack_public_path__ + "img/aq.65afe1f1.svg";